export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Insurance',
      items: [
        'Valid HVAC contractor license',
        'General liability insurance',
        'Workers compensation coverage',
        'EPA certification for refrigerant handling'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years in business in El Paso',
        'Manufacturer certifications',
        'Specialized training and credentials',
        'Experience with your system type'
      ]
    },
    {
      category: 'Services & Pricing',
      items: [
        'Detailed written estimates',
        'Warranty on parts and labor',
        'Emergency service availability',
        'Maintenance plan options'
      ]
    },
    {
      category: 'Reputation & Reviews',
      items: [
        'Online reviews and ratings',
        'BBB accreditation',
        'Local references',
        'Professional affiliations'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            HVAC Contractor Comparison Checklist
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Use this checklist to evaluate and compare HVAC contractors before making your decision.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg border border-orange-100"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-600 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-4">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-orange-600 text-xl mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-orange-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Find Your HVAC Contractor?
          </h3>
          <p className="text-lg mb-6 text-orange-50">
            Get free quotes from multiple licensed contractors and compare their services.
          </p>
          <button className="px-8 py-4 bg-white text-orange-600 font-semibold rounded-lg hover:bg-orange-50 transition-colors whitespace-nowrap">
            Get Free Quotes Now
          </button>
        </div>
      </div>
    </section>
  );
}
